export { default } from '@onclicks/sharedutils/canUseDOM'
